import type { CSSProperties } from 'react';
import { GIANT_IDS, type GiantId } from '../../../../../../domain/ids/ids';
import './GiantIcon.css';
import { GIANT_BADGE_ICONS, GIANT_ICONS } from './giantIconAssets';

/** @deprecated Используйте {@link GiantId}. */
export type GiantIconName = GiantId;

export type GiantIconVariant = 'default' | 'badge';

export type GiantIconProps = {
  name: GiantId;
  /** `badge` — circular Figma badge art (new_delivery_screen). */
  variant?: GiantIconVariant;
  className?: string;
  style?: CSSProperties;
};

/** All giant arts stay mounted; only the selected one is visible. */
export function GiantIcon({ name, variant = 'default', className, style }: GiantIconProps) {
  const icons = variant === 'badge' ? GIANT_BADGE_ICONS : GIANT_ICONS;
  return (
    <>
      {GIANT_IDS.map((id) => (
        <img
          key={id}
          className={[
            'giant-icon',
            `giant-icon--${id}`,
            variant === 'badge' ? 'giant-icon--badge' : null,
            id === name ? null : 'giant-icon--hidden',
            className,
          ]
            .filter(Boolean)
            .join(' ')}
          style={id === name ? style : undefined}
          src={icons[id]}
          alt=""
          draggable={false}
          aria-hidden={id !== name}
        />
      ))}
    </>
  );
}
